var map = {
	"./banner.png": 352,
	"./banner_footer.png": 2900,
	"./banner_icon.png": 3150,
	"./education-icon1.png": 6825,
	"./education-icon2.png": 738,
	"./education-icon3.png": 1867,
	"./education-icon4.png": 1956,
	"./education-icon5.png": 8637,
	"./education-icon6.png": 7430,
	"./education.png": 470,
	"./enterprise-icon1.png": 544,
	"./enterprise-icon2.png": 1835,
	"./enterprise-icon3.png": 706,
	"./enterprise-icon4.png": 4957,
	"./enterprise-icon5.png": 1924,
	"./enterprise.png": 5647,
	"./government.png": 2611,
	"./governmentData-icon1.png": 5380,
	"./governmentData-icon2.png": 8943,
	"./governmentData-icon3.png": 854,
	"./governmentData-icon4.png": 5113,
	"./home_bg.png": 3365,
	"./management.png": 7655,
	"./treatment.png": 2504,
	"./vocational.png": 5698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1772;